import { render, staticRenderFns } from "./MarketingEmailListItem.vue?vue&type=template&id=2f9c9308&scoped=true"
import script from "./MarketingEmailListItem.vue?vue&type=script&lang=js"
export * from "./MarketingEmailListItem.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailListItem.vue?vue&type=style&index=0&id=2f9c9308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c9308",
  null
  
)

export default component.exports